import { WaveAiIcon } from "../presence/WaveAiIcon";

type Props = {
  onClick: () => void;
};

export function WaveBlockAgentButton({ onClick }: Props) {
  return (
    <button
      type="button"
      className="wave-block-ai-btn"
      aria-label="Chiedi a Whale"
      title="Chiedi a Whale"
      onClick={onClick}
    >
      <WaveAiIcon className="wave-block-ai-btn-icon" />
    </button>
  );
}
